<template>
  <div>
    <div class="container-fluid featured-page-image">
      <div class="feature-header-page">
        <h1>About</h1>
      </div>
    </div>
    <div class="container">
      <div class="intro">
        <h2>About KD Roofing</h2>
        <hr>
      </div>
      <div class="internal-content">
        <p>We are a well-established company and we are based in the Hingham area of Norfolk (East Anglia).</p>
        <p>We have a wealth of experience in all types of Roofing. Although we like to provide an excellent service in
          our local area, using local merchants to source our materials, we do travel to all areas. We pride ourselves
          on our track record and have gained many contracts through recommendations, both in the private and
          commercial sectors.</p>
        <p>We offer the complete range of works, from small repairs, storm damage, flashing&#8217;s and maintenance
          packs to complete new roofs in tiles, slates, shingles, flat roofing systems and lead work. We can renew
          your fascias, soffits and guttering in UPVC, making them more or less maintenance free. We are able to
          re-point chimneys or even demolish them if they are no longer required. We install roof windows and fit all
          types of roof ventilation, which is essential in the prevention of condensation and mould.</p>
        <p>We are more recently carrying out the installation of Solar panels. We like to provide a service whereby we
          help and advise the customer on choosing the exact product and finish that they require. We provide a free
          estimate listing our recommendations and costs for the completion of works.</p>
        <p>Health and Safety for both the Customer and ourselves is paramount, we like to use an established
          Scaffolding Company to provide safe working access when and where necessary. We like to ensure our projects
          are kept clean and are carried out with as little as possible inconvenience to the Customer. We can help
          with Insurance claims and we can liaise with Architects and Local Authorities if necessary. We have an up to
          date Public and Employers liability Insurance.</p>
        <p>Please contact us if you feel we can be of assistance!</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'About'
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/About.vue